var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.dde992ceebddc769877e05ea838faf9d.svg#T';
                    var viewUrl = 'sprites.dde992ceebddc769877e05ea838faf9d.svg#view-T';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };